import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuLines, CloseX } from './vd/LineArt';

const NAV = [
  { label: 'Domov', to: '/' },
  { label: 'Prvi dnevi po porodu', to: '/prvi-dnevi-po-porodu' },
  { label: 'Učiva se hranjenja', to: '/uciva-se-hranjenja' },
  { label: 'Tvoje telo', to: '/tvoje-telo' },
  { label: 'Povezanost', to: '/povezanost' },
  { label: 'O Val Dotika', to: '/o-val-dotika' },
  { label: 'Blog', to: '/blog' },
];

const Header = ({ onBrochureClick, showBrochureCTA = true }) => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-40 transition-all ${scrolled ? 'bg-vd-bg/95 backdrop-blur-md border-b border-vd-soft' : 'bg-vd-bg/70'}`}
      data-testid="vd-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between gap-4">
        <Link to="/" className="font-serif text-2xl text-vd-text hover:text-vd-accent transition-colors tracking-tight whitespace-nowrap" data-testid="vd-logo">
          Val Dotika
        </Link>

        <nav className="hidden lg:flex items-center gap-4 xl:gap-5 text-[13px] xl:text-sm text-vd-text/80" data-testid="vd-nav">
          {NAV.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              className={`hover:text-vd-accent transition-colors whitespace-nowrap ${location.pathname === n.to ? 'text-vd-accent' : ''}`}
              data-testid={`vd-nav-${n.to.replace(/\//g, '') || 'home'}`}
            >
              {n.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            className="lg:hidden text-vd-text p-2"
            onClick={() => setOpen(!open)}
            aria-label="Menu"
            data-testid="vd-menu-toggle"
          >
            {open ? <CloseX size={22} /> : <MenuLines size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-vd-bg border-t border-vd-soft" data-testid="vd-mobile-menu">
          <nav className="max-w-7xl mx-auto px-4 py-4 flex flex-col gap-1">
            {NAV.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                className={`py-2.5 px-2 rounded-md text-sm hover:bg-white/60 transition-colors ${location.pathname === n.to ? 'text-vd-accent font-medium' : 'text-vd-text/85'}`}
              >
                {n.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
